module.exports = __webpack_public_path__ + "img/charge.29a72c3b.png";